<template>
  <div class="main">
    <el-card class="box-card">
      <div class="title">修改密码<span class="required">(请5分钟内修改完成)</span></div>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword" autocomplete="off" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="freshPassword">
          <el-input type="password" v-model="ruleForm.freshPassword" minlength="8" maxlength="16" autocomplete="off"
                    placeholder="新密码8-16位，且包含数字，符号和字母"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" minlength="8" maxlength="16"
                    placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
  export default {
    name: 'changePassword',
    data() {
      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('年龄不能为空'));
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
          } else {
            if (value < 18) {
              callback(new Error('必须年满18岁'));
            } else {
              callback();
            }
          }
        }, 1000);
      };
      var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入旧密码'));
        }else{
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          if (this.ruleForm.freshPassword !== '') {
            let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>,.\/]).{8,16}/;
            if(reg.test(this.ruleForm.freshPassword)){
              this.$refs.ruleForm.validateField('checkPass');
            }else{
              callback(new Error('新密码8-16位，且包含数字，符号和字母'));
            }
          }
          callback();
        }
      };
      var validatePass3 = (rule, value, callback) => {
        if (value === '') {
            if(!this.ruleForm.freshPassword){
              callback(new Error('请输入新密码后输入确认密码'));
            }
        }else{
          if(this.ruleForm.freshPassword){
            if((value !== this.ruleForm.freshPassword)){
                callback(new Error('两次输入新密码不一致!'));
            }else{
              callback();
            }
          }else{
            callback(new Error('请输入新密码且和确认密码保持一致!'));
          }
        }

      };
      return {
        ruleForm: {
          oldPassword: '',
          freshPassword: '',
          checkPass:''
        },
        rules: {
          oldPassword: [
            {validator: validatePass1, trigger: 'blur'},
            { required: true,message: '请输入旧密码',trigger: 'blur'},
          ],
          freshPassword: [
            {validator: validatePass2, trigger: 'blur'},
            { required: true,message: '请输入新密码',trigger: 'blur'},
          ],
          checkPass: [
            {validator: validatePass3, trigger: 'blur'},
            { required: true,message: '请输入新密码后输入确认密码',trigger: 'blur'},
          ],
        }
      };
    },
    methods: {
      submitForm(formName) {
        var _this=this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var model={
              key:_this.$route.query.key,
              oldPassword:_this.ruleForm.oldPassword,
              freshPassword:_this.ruleForm.freshPassword,
            };
            _this.$axios.post('/rm-user-manage/api/admin/user/forceChangePassword', model).then(res => {
              console.log(res)
              if(res.data.code==0){
                _this.$message.success('修改成功');
                setTimeout(() => {
                  _this.$router.push('/auth/login');
                }, 800);
              }
            }).catch((err) => {
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style scoped lang="scss">
  .main {
    width: 100%;
    height: 100%;
    .box-card {
      width: 560px;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .title {
        height: 20px;
        line-height: 20px;
        padding: 0px;
        text-align: left;
        font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// changePassword.vue?14c51f4a